export default __webpack_public_path__ + "static/media/closet5-after2-768w.6ced363c.png";